export default __webpack_public_path__ + "static/media/machu_picchu-landscape.4e95acb7.jpg";